import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Steps from "@ADC/components/Pages/Home/Form/Steps";
import BBBCertified from "@ADC/components/Views/BBBCertified";
import { Button } from "@ADC/components/common";

const Home = () => {
  const points = [
    "Exclusive Program for Texas Residents",
    "Specialists for resolving $50K to $300K+",
    "Free No-Obligation Consultation",
    "Receive up to 40% Lower Fees*",
  ];

  return (
    <section id="header" className="relative bg-green-700">
      <div className="flex flex-col md:flex-row items-center max-md:h-full max-lg:h-[400px] max-xl:h-[420px] xl:h-[66vh]">
        <div className="w-full h-full">
          <StaticImage
            src="https://adc-dr-assets.s3.amazonaws.com/affordabledebtconsolidation/images/home-hero-img-mobile.webp"
            className="h-full w-full md:!hidden"
            loading="eager"
            alt="Banner"
          />
          <StaticImage
            src="https://adc-dr-assets.s3.amazonaws.com/affordabledebtconsolidation/images/home-hero-img.webp"
            className="h-full w-full max-md:!hidden scale-x-[-1]"
            loading="eager"
            alt="Banner"
          />
        </div>
        <div className="w-full h-full flex items-center justify-center bg-custom-primary max-md:hidden">
          <div className="p-8 max-w-[500px] xl:max-w-[33vw]">
            <h1 className="text-[2.6rem] xl:text-[2.6vw] text-white [text-shadow:_5px_5px_12px_black] font-semibold capitalize">
              debt relief you can count on.
            </h1>
            <div className="text-white flex flex-col font-medium text-xl my-6">
              {points.map((point, index) => (
                <p
                  className="flex items-center max-lg:text-base xl:text-[1.4vw] leading-normal"
                  key={index}
                >
                  <img
                    src="/svgs/check-orange.svg"
                    className="me-2 w-[1.1vw]"
                    height={14}
                    alt="Check"
                  />{" "}
                  {point}
                </p>
              ))}
            </div>
            <Button
              className="!bg-sky-700 !py-0.5 2xl:!py-[0.6vw] !px-20 xl:!px-[4vw] !rounded-lg !text-2xl xl:!text-[1.5vw] mx-auto hover:!bg-sky-800"
              label="Apply Now"
              variant="primary"
              link={{
                is: true,
                isExternal: false,
                path: "/apply/",
              }}
            />
          </div>
        </div>
        <div className="pb-8 px-4 md:hidden">
          <Steps />
        </div>
      </div>

      <BBBCertified />
    </section>
  );
};

export default Home;
